import { put } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';

import { IBusinessUnitRights, getUser } from '@crm-framework/auth';
import { handleServerError } from '@crm-framework/utils';

import { notificationsApi } from './api';
import { notificationsActions } from './NotificationsStore';
import {
  getIsBUFilterDisabled,
  getBUFilterValue as _getBUFilterValue,
  getBUSelectOptions,
} from './selectors';

function* getBusinessUnitsDictionary() {
  try {
    return yield* call(notificationsApi.getBusinessUnitsApi);
  } catch (e) {
    handleServerError(e);

    return [];
  }
}

const extractBusinessUnitIDsFromUser = (
  businessUnitRights: IBusinessUnitRights
) =>
  Array.from(
    Object.values(businessUnitRights).reduce((acc, businessUnitIDs) => {
      businessUnitIDs?.forEach((id) => acc.add(id));

      return acc;
    }, new Set<number>())
  );

function* getFilteredDictionary(businessUnitRights: IBusinessUnitRights) {
  const businessUnits = yield* call(getBusinessUnitsDictionary);

  const userBusinessUnitIDs = yield* call(
    extractBusinessUnitIDsFromUser,
    businessUnitRights
  );

  const filteredDictionary = businessUnits.filter(({ id }) =>
    userBusinessUnitIDs.includes(id)
  );

  return filteredDictionary;
}

// setting available (filtered) business units select options in notification state
export function* getBusinessUnits() {
  const user = yield* select(getUser);

  if (user) {
    const { businessUnitRights } = user;

    const filteredDictionary = yield* call(
      getFilteredDictionary,
      businessUnitRights
    );

    const selectOptions = filteredDictionary.map(({ id, name }) => ({
      label: name,
      value: id,
    }));

    yield put(
      notificationsActions.setBusinessUnitsSelectOptions(selectOptions)
    );
  }
}

export function* getBUFilterValue() {
  const buFilterValue = yield* select(_getBUFilterValue);

  const buSelectOptions = yield* select(getBUSelectOptions);

  const isBUFilterDisabled = yield* select(getIsBUFilterDisabled);

  const isBUFilterEmpty =
    buSelectOptions.length === buFilterValue.length ||
    !buFilterValue.length ||
    isBUFilterDisabled;

  return isBUFilterEmpty ? undefined : buFilterValue;
}
